import { render, staticRenderFns } from "./BidDashboardActivity.vue?vue&type=template&id=3b8e807c&scoped=true"
import script from "./BidDashboardActivity.vue?vue&type=script&lang=js"
export * from "./BidDashboardActivity.vue?vue&type=script&lang=js"
import style0 from "./BidDashboardActivity.vue?vue&type=style&index=0&id=3b8e807c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8e807c",
  null
  
)

export default component.exports